import React, { useState } from "react";
import ReactDOM from "react-dom";
import MUIDataTable from "mui-datatables";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import axios from 'axios';
import ViewExpense from "./ViewExpense";
import { Router, Switch, Route } from "react-router-dom";
import apiBaseUrl from './API'



function UserExpenseView(props) {
  const [responsive, setResponsive] = useState("vertical");
  const [tableBodyHeight, setTableBodyHeight] = useState("500px");
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");
  //const [result, updateResult] = useState([]);
  //const [books, updateBooks] = React.useState([]);

    console.log(props.role)

//   const changeInput = (e) => {todos.map(items => items.id === parseInt(e.target.value) && (items.completed = e.target.checked));
//  setTodos([...todos], todos);}
  const columns = ["Customer Name", "Project Name", "Project Code", "Location", "Bike Type", "KM", "Bike expense", "Local", "Bus",
                 "Train", "Food", "Hotel","Total", "Date",  "Status" ,"Description"];
        
  const options = {
    filter: true,
    filterType: "dropdown",
     responsive,
    tableBodyHeight,
    tableBodyMaxHeight,

  };


const data = [[]]
const [responseData, setResponseData] = useState({});
const [hasError, setErrors] = useState(false);


React.useEffect(() => {
    async function fetchData() {
      const res = await fetch(apiBaseUrl+"/getExpense/?userid="+props.userid+"&role="+props.role);
      res
        .json()
        .then(res => setResponseData(res))
        .catch(err => setErrors(err));
    }

    fetchData();
  },[]);
   console.log("RAW ",responseData)
   for(var i=0; i < responseData.length; i++) {
    var na = []
   // na.push(responseData[i].name)
    na.push(responseData[i].cname)
    na.push(responseData[i].project_name)
    na.push(responseData[i].project_code)
    na.push(responseData[i].location)
    na.push(responseData[i].typeOfBike)
    na.push(responseData[i].bikeKM)
    na.push(responseData[i].bike)
    na.push(responseData[i].car)
    na.push(responseData[i].bus)
  //  na.push(responseData[i].flight)
    na.push(responseData[i].train)
    na.push(responseData[i].food)
    na.push(responseData[i].hotel)
    na.push(responseData[i].total)
    na.push(new Date(responseData[i].e_date).toLocaleDateString('pt-PT'))
    na.push(responseData[i].status)
    na.push(responseData[i].description)


    data.push(na)
    na = [];
    }
    // console.log('d ',data)

    
  return (
<div>
    
 <React.Fragment>
     
      <MUIDataTable
        title={"Expense List"}
        data={data}
        columns={columns}
        options={options}

      />
    </React.Fragment>         
    </div>
    );
}

export default UserExpenseView


// WEBPACK FOOTER //
// ./src/UserExpenseView.js